import { IGlobalState } from '../../../Root/store/appReducer'

export const getSuperAdminTargetCompany = (state: IGlobalState) => state.superAdmin.targetCompany
export const getSuperAdminSearchResults = (state: IGlobalState) => state.superAdmin.searchResults
export const getSuperAdminSearchLoading = (state: IGlobalState) => state.superAdmin.searchLoading
export const getSuperAdminTotalCount = (state: IGlobalState) => state.superAdmin.totalCount
export const getSuperAdminPage = (state: IGlobalState) => state.superAdmin.page
